import script from "./TrailContextBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrailContextBar.vue?vue&type=script&setup=true&lang=ts"

import "./TrailContextBar.vue?vue&type=style&index=0&id=6a473aae&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a473aae"]])

export default __exports__